import { render, staticRenderFns } from "./CookieList.vue?vue&type=template&id=74b2cc16&scoped=true&"
import script from "./CookieList.vue?vue&type=script&lang=ts&"
export * from "./CookieList.vue?vue&type=script&lang=ts&"
import style0 from "./CookieList.vue?vue&type=style&index=0&id=74b2cc16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2cc16",
  null
  
)

export default component.exports